import React from "react";
import {LogoMaestroIcon} from "../../../../../../../assets/svg/logo-maestro.icon";
import {CardNetworkModel} from "./card-network.model";
import {CardNetworksEnum} from "../../payment-method-codes.enum";
import {ICardNetworkIconOptions} from "./card-network.view-model.interface";

export class MaestroCardNetworkModel extends CardNetworkModel {
    constructor() {
        super(CardNetworksEnum.Maestro);
    }
    get name(): string {
        return "Maestro";
    }

    renderIcon(options?: ICardNetworkIconOptions): React.ReactElement | null {
        return (<LogoMaestroIcon {...options}/>);
    }
}